<div class="dn-wrapper">

  <!-- Error Alert -->
  <div class="dn-alert" [hidden]="!showErrorAlert" [class.closing]="isClosingAlert">
    <div class="dn-alert-content">
      <tui-icon icon="tuiIconAlertCircle" style="color:#dc2626;flex-shrink:0;height:20px"></tui-icon>
      <span>{{ textAlert }}</span>
      <tui-icon icon="tuiIconCloseLarge" (click)="onErrorAlertClosed()" style="cursor:pointer;margin-left:auto;color:#dc2626;height:16px"></tui-icon>
    </div>
  </div>

  <div class="dn-body">

    <!-- LEFT PANEL: Tabs -->
    <div class="dn-left">

      <tui-tabs [(activeItemIndex)]="activeTabIndex" class="dn-tabs">
        <button tuiTab>{{ 'delivery-note.upload_your_file' | translate }}</button>
        <button tuiTab>{{ 'delivery-note.link' | translate }}</button>
      </tui-tabs>

      <!-- Tab 0: Upload file -->
      <div class="modal-tab-content" *ngIf="activeTabIndex === 0">

        <p class="modal-title">{{ 'delivery-note.upload_your_file' | translate }}</p>
        <p class="modal-description">{{ 'delivery-note.drag_or_click_to_upload' | translate }}</p>

        <div class="info-box">
          <tui-icon icon="tuiIconInfo" style="color:#3b82f6;flex-shrink:0;height:20px"></tui-icon>
          <span>{{ 'delivery-note.files_saved_for_future' | translate }}<span class="fw-600">{{ 'delivery-note.saveFilesForAnotherServices' | translate }}.</span></span>
        </div>

        <div class="template_checkbox">
          <input type="checkbox" id="saveTemplate" [(ngModel)]="saveAsPermanentFile" />
          <label for="saveTemplate">{{ 'delivery-note.saveFilesForAnotherServices' | translate }}</label>
        </div>

        <div class="input-file-container">
          <tui-input-files
            class="input-files-upload"
            [maxFileSize]="maxFileSize"
            [multiple]="true"
            [ngModel]="files"
            (ngModelChange)="onChange($event)"
            (reject)="onReject($event)"
          >
            <input tuiInputFiles accept="application/pdf" multiple />

            <ng-template let-dragged>
              <div *ngIf="dragged; else baseDropzone" class="dn-dropzone-content">
                <tui-icon icon="tuiIconFile" class="dn-dropzone-icon"></tui-icon>
                <span>{{ 'delivery-note.dropFilesHere' | translate }}</span>
              </div>
              <ng-template #baseDropzone>
                <div class="dn-dropzone-content">
                  <tui-icon icon="tuiIconFile" class="dn-dropzone-icon"></tui-icon>
                  <span>{{ 'delivery-note.dragOr' | translate }}&nbsp;<a tuiLink>{{ 'delivery-note.uploadYourFile' | translate }}</a></span>
                </div>
              </ng-template>
            </ng-template>

          </tui-input-files>

          <tui-files class="file-items-list" [max]="2">
            <tui-file
              *ngFor="let file of rejected"
              state="error"
              [file]="file"
              (removed)="onRemove(file)"
              [showSize]="true"
            ></tui-file>
            <tui-file
              *ngFor="let file of files"
              state="normal"
              [file]="file"
              (removed)="onRemove(file)"
              [showSize]="true"
            ></tui-file>
          </tui-files>
        </div>

      </div>

      <!-- Tab 1: Link -->
      <div class="modal-tab-content" *ngIf="activeTabIndex === 1">

        <p class="modal-title">{{ 'delivery-note.add_your_link' | translate }}</p>
        <p class="modal-description">{{ 'delivery-note.add_link_and_name' | translate }}</p>

        <div class="info-box">
          <tui-icon icon="tuiIconInfo" style="color:#3b82f6;flex-shrink:0;height:20px"></tui-icon>
          <span>{{ 'delivery-note.files_saved_for_future' | translate }}<span class="fw-600">{{ 'delivery-note.saveLinksForAnotherServices' | translate }}.</span></span>
        </div>

        <div class="template_checkbox">
          <input type="checkbox" id="saveTemplateLink" [(ngModel)]="saveAsPermanentLink" />
          <label for="saveTemplateLink">{{ 'delivery-note.saveLinksForAnotherServices' | translate }}</label>
        </div>

        <div class="dn-inputs-group">
          <div class="dn-input-field">
            <span class="link_title">{{ 'delivery-note.link_v2' | translate }}</span>
            <input type="url" [(ngModel)]="link_url" placeholder="{{ 'delivery-note.write_your_url' | translate }}" class="link-input" />
          </div>
          <div class="dn-input-field">
            <span class="link_title">{{ 'delivery-note.file_name' | translate }}</span>
            <input type="text" [(ngModel)]="link_name" placeholder="{{ 'delivery-note.file_name' | translate }}" class="link-input" />
          </div>
        </div>

      </div>

    </div>

    <!-- RIGHT PANEL: Saved files -->
    <div class="dn-right">

      <p class="modal-title">{{ 'delivery-note.add_saved_files' | translate }}</p>
      <p class="modal-description">{{ 'delivery-note.select_files_to_add' | translate }}:</p>

      <div class="search-bar">
        <div>
          <tui-icon icon="tuiIconSearch" class="search-icon"></tui-icon>
          <input
            #searchInput
            (input)="onSearchChange()"
            type="text"
            placeholder="{{ 'delivery-note.search_file' | translate }}"
            class="search-bar-input"
          />
          <tui-icon icon="tuiIconCloseLarge" class="close-icon" (click)="clearFilter()"></tui-icon>
        </div>

        <div class="file-list">
          <div
            *ngFor="let file of savedFiles"
            class="file-item"
            [ngClass]="{'selected': file.checked, 'blocked': isDocumentBlocked(file)}"
            (click)="toggleSavedFile(file)"
          >
            <div>
              <tui-icon *ngIf="file.type === DeliveryNoteDocumentType.Document" icon="tuiIconFile" style="height:20px"></tui-icon>
              <tui-icon *ngIf="file.type === DeliveryNoteDocumentType.Link" icon="tuiIconLink" style="height:20px"></tui-icon>
            </div>
            <div class="file-details">
              <div>{{ file.name }}</div>
              <div *ngIf="file.type === DeliveryNoteDocumentType.Link">
                <span class="file-meta">{{ 'delivery-note.link_v2' | translate }}: {{ file.link }}</span>
              </div>
              <div *ngIf="file.type === DeliveryNoteDocumentType.Document && file.uploadedDate">
                <span class="file-meta">{{ 'delivery-note.uploaded_on' | translate }}: {{ file.uploadedDate }}</span>
              </div>
            </div>
            <div class="file-size" *ngIf="file.type === DeliveryNoteDocumentType.Document">{{ file.fileSize }}</div>
            <div class="check">
              <input type="checkbox" [checked]="file.checked" style="pointer-events: none;" />
            </div>
            <div class="delete-saved-icon">
              <tui-icon icon="tuiIconTrash" (click)="deleteSavedFile(file, $event)"></tui-icon>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

  <!-- Footer -->
  <div class="dn-footer">

    <div class="dn-button-container">
      <div (click)="cancel()" class="dn-btn dn-btn-cancel">{{ 'delivery-note.cancel_operation' | translate }}</div>
    </div>

    <div class="dn-button-container">
      <div (click)="submit()" class="dn-btn dn-btn-submit" [ngClass]="{'disabled': disableButton()}">{{ 'delivery-note.upload_files' | translate }}</div>
    </div>

  </div>

</div>
